module.exports = __webpack_public_path__ + "d33f429cef0d70c242530e603b3082b0.svg";